// Modules.
import { connect } from 'react-redux';

// Components.
import SearchMenuItem from './SearchMenuItem';

// Store.
const mapStateToProps = state => ({
    gvars: state.global.gvars,
});

export default connect(mapStateToProps)(SearchMenuItem);
